// extracted by mini-css-extract-plugin
export default {"label":"DetailsField_label__AqTX6","value":"DetailsField_value__Hsl3t"};